import React from 'react';

const ExtraElements = () => {
    return (
        <section id="extra-elems">
        <aside className="mobile-menu">
          <ul className="nav-menu__nav">
            <li className="nav-menu__nav-item">
              <a href="./index.html" className="nav-item-link">Home</a>
            </li>
            <li className="nav-menu__nav-item">
              <a href="#" className="nav-item-link">Explore</a>
            </li>
            <li className="nav-menu__nav-item">
              <a href="#" className="nav-item-link">Stream</a>
            </li>
            <li className="nav-menu__nav-item">
              <a href="#" className="nav-item-link">Bets</a>
            </li>
            <li className="nav-menu__nav-item">
              <a href="#" className="nav-item-link">NFT Marketplace</a>
            </li>
            <li className="nav-menu__nav-item">
              <a href="#" className="nav-item-link">Whitepaper</a>
            </li>
          </ul>
          <div className="user-group">
            <div className="cta-group">
              <a href="#" className="you-btn"> Buy Premium </a>
              <a href="#" className="you-btn"> Connect Wallet </a>
            </div>
            <div className="dropdown user-details-btn">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="userCridentials"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-circle-user"></i>
                <span className="icon">
                  <svg
                    version="1.2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 12"
                    width="18"
                    height="12"
                  >
                    <path
                      className="a" style={{  fill: '#fff'}}
                      d="m0.9 0.3l8.1 6 8.1-6v5.1l-8.1 6-8.1-6z"
                    />
                  </svg>
                </span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="userCridentials">
                <li><a className="dropdown-item" href="#">Dashboard</a></li>
                <li><a className="dropdown-item" href="#">Settings</a></li>
              </ul>
            </div>
          </div>
        </aside>
      </section>
    );
};

export default ExtraElements;